"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UploadModal',
  data: function data() {
    return {
      dialogVisible: false,
      list: [],
      queryParams: {
        limit: 10,
        page: 1
      },
      total: 0
    };
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
      this.onQuery();
    },
    close: function close() {
      this.dialogVisible = false;
      this.list = [];
    },
    onQuery: function onQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      (0, _store.importHistory)(this.queryParams).then(function (res) {
        _this.total = res.total;
        _this.list = res.list;
      });
    },
    onPageChange: function onPageChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    onSizeChange: function onSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    }
  }
};